export interface UnparsedTripDateParams {
  checkin: UnparsedDate
  checkout: UnparsedDate
}

export interface UnparsedTripParams extends UnparsedTripDateParams {
  duration: number | string
  fuzzyness: number | string
  pax: number | string
}

export function getTripParams({
  checkin,
  checkout,
  duration,
  fuzzyness,
  pax,
}: Partial<UnparsedTripParams>): Partial<TripParams> {
  return {
    checkin: tryParseDate(checkin)!,
    checkout: tryParseDate(checkout)!,
    duration: tryParseInt(duration),
    fuzzyness: tryParseInt(fuzzyness),
    pax: tryParseInt(pax)!,
  }
}

export function getTripParamsFromState({
  dates,
  pax,
}: SearchState): Partial<TripParams> {
  return {
    checkin: dates?.startDate,
    checkout: dates?.endDate,
    duration: dates?.duration,
    fuzzyness: dates?.flexDays,
    pax: tryParseInt(pax)!,
  }
}

export function getTripDateRange({
  checkin,
  checkout,
}: Partial<UnparsedTripDateParams>): DateRange {
  return { start: tryParseDate(checkin), end: tryParseDate(checkout) }
}

export function getTripDateQuery({
  checkin,
  checkout,
}: Partial<UnparsedTripDateParams>) {
  return {
    checkin: checkin && toDate(checkin),
    checkout: checkout && toDate(checkout),
  }
}

export function getTripDuration(trip: Partial<TripParams>): number {
  return getDateRangeDuration(getTripDateRange(trip))
}

export function isTripValid(
  trip: Partial<TripParams | Trip> | undefined | null,
): trip is TripParams {
  return !!(trip && trip.checkin && trip.checkout && trip.pax)
}

export function isAccommodationTripValid(
  trip: Partial<Trip> | undefined | null,
): trip is Trip {
  return !!(
    trip &&
    trip.checkin &&
    trip.checkout &&
    trip.pax &&
    typeof trip.duration === 'number' &&
    typeof trip.price === 'number'
  )
}

export function getTripOrigPrice({ price, reduction }: Trip): number {
  return price / ((100 - (reduction ?? 0)) / 100)
}

export function isTripFlexible(trip: Partial<UnparsedTripParams>): boolean {
  return !!trip.duration || !!trip.fuzzyness
}
